import { useState } from "react";
import { ArrowRight, CheckCircle2, Mail } from "lucide-react";
import { toast } from "sonner";

/**
 * EmailCapture — Phase 1 is VISUAL ONLY (no DB storage per current scope).
 * Submitting shows a success state + toast. Wire to /api/leads in a later phase.
 */
export const EmailCapture = ({
  source = "homepage",
  compact = false,
}) => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!valid) {
      toast.error("Please enter a valid email address.");
      return;
    }
    // VISUAL ONLY — not persisted in Phase 1.
    setDone(true);
    toast.success("You're on the list. Welcome to AI First Sports.");
  };

  if (done) {
    return (
      <div
        data-testid="email-capture-success"
        className="flex items-center justify-center gap-3 rounded-xl border border-brand-cyan/30 bg-brand-navy/40 px-6 py-5 text-brand-cyan"
      >
        <CheckCircle2 className="h-5 w-5 shrink-0" />
        <p className="text-sm font-medium text-white">
          Subscribed — match intelligence is on its way.
        </p>
      </div>
    );
  }

  return (
    <form
      data-testid="email-capture-form"
      onSubmit={handleSubmit}
      data-source={source}
      className={`flex w-full flex-col gap-3 sm:flex-row ${compact ? "" : "sm:gap-3"}`}
    >
      <div className="relative flex-1">
        <Mail className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-brand-silver" />
        <input
          data-testid="email-capture-input"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com"
          aria-label="Email address"
          className="h-12 w-full rounded-lg border border-brand-navy bg-brand-bg pl-11 pr-4 text-sm text-white placeholder:text-brand-silver/60 outline-none transition-all duration-300 focus:border-brand-royal focus:ring-2 focus:ring-brand-cyan/60"
        />
      </div>
      <button
        data-testid="email-capture-submit"
        type="submit"
        className="group inline-flex h-12 items-center justify-center gap-2 rounded-lg bg-brand-royal px-6 text-sm font-semibold text-white transition-all duration-300 hover:bg-brand-cyan hover:text-brand-bg"
      >
        Get Free Insights
        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
      </button>
    </form>
  );
};

export default EmailCapture;
